/**
 * 「芯を先に」（2026-09-30 console/core-first）の日本語（en.coreFirst.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 表記の決め事は ja.ts の冒頭と同じ（説明はです・ます、日本語と英字の間に空白を入れない）。
 */
import type { enCoreFirst } from './en.coreFirst';

type CoreFirstMessages = { [K in keyof typeof enCoreFirst]: string };

export const jaCoreFirst: CoreFirstMessages = {
  'nav.group.extras': '追加の機能',

  'overview.ask.body': 'つないだAIエージェントに、普段の言葉で頼みます。プロジェクトの名前（{name}）を添えると、どのプロジェクトの話かエージェントに伝わります。',
  'overview.ask.connect': 'まだつないでいなければ、{link}のコピペの1行でつなぎます。',
  'overview.ask.connectLink': '「AIエージェントをつなぐ」の画面',
  'overview.byHand': '自分で打つなら',

  'hosting.empty.ask': 'AIエージェントに「公開して」と頼みます。まずテスト用のアプリに公開され、公開中のアプリにも出すかを1回聞かれます。',
  'hosting.empty.cli': '自分で打つなら: {cmd}',

  'recover.verifiedInvite': '招待クレジット{amount}が入りました（利用料だけに使えます）。',

  'invite.fieldHintCredit': '入れると、メールの確認のあとに利用料だけに使える招待クレジットが入ります（GoogleやGitHubで登録したときはすぐに入ります）。',
  'invite.fieldHintAmount': '入れると、メールの確認のあとに利用料だけに使える{amount}分が入ります（GoogleやGitHubで登録したときはすぐに入ります）。'
};
